var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Выход'), icon: 'vip_icon icon_exit', path: `../../../login`},"linkCl":_vm.logOut}})
}
var staticRenderFns = []

export { render, staticRenderFns }